export default __webpack_public_path__ + "static/0-eff7e3e97555a341d927dcefac97916e.png";